var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('div',{staticClass:"created-date"},[_vm._v(" Criado em: "+_vm._s(_vm.formattedDate)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }